module.exports = __webpack_public_path__ + "img/allianz.ea0326d4.png";